import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledErrorMessageBlock } from '../../base/forms/formik';
import { Button } from '../../base';
import { fadeInAndUp } from '../../base/keyframes/fades';
import { submitApplicationFormFiles } from '../../../actions/applicationActions';
import media from '../../base/media';
import { isSpecialApplication } from '../../../helpers/linkResolver/linkResolver';

export const StyledFormSubmissionError = styled(StyledErrorMessageBlock)`
	font-size: 1.8rem;
	margin-bottom: 1rem;

	${media.tablet`
		margin-right: 1rem;
		margin-bottom: 0;
	`}

`;

const StyledFormSubmissionInfo = styled.div`
	font-size: 1.8rem;
	margin-bottom: 1rem;

	${media.tablet`
		margin-right: 1rem;
		margin-bottom: 0;
	`}

	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.success};
	opacity: 0;
	animation: ${fadeInAndUp} 350ms ease forwards;
`;

const StyledButtonWrapper = styled.div`
	margin-bottom: 1rem;

	${media.tablet`
		margin-right: 1rem;
		margin-bottom: 0;
	`}

`;

const FormSubmissionInfo = ({
	errors,
	formSubmissionError,
	formSubmissionErrorStatus,
	fileSubmissionError,
	fileSubmissionLoading,
	activeApplicationId,
	files,
	dispatch
}) => {
	const localFieldErrorsPresent = Object.keys(errors).length > 0;

	const onUploadFiles = () => {
		let type 
		if (isSpecialApplication(window.location.pathname)){
			type = 'grindavik'
		}
		dispatch(submitApplicationFormFiles(activeApplicationId, files, type));
	};

	const errorText = () => {
		switch(formSubmissionErrorStatus) {
			case 401:
				return (
					<span>Gat ekki skilað umsókn, notandi er ekki skráður inn.</span>
				);
			default:
				return (
					<span>Gat ekki skilað umsókn, eitthvað fór úrskeiðis.</span>
				);
		}
	};

	return (
		<>
			<StyledFormSubmissionInfo>
				{
					fileSubmissionLoading && (
						<span>Hlaða upp skrám..</span>
					)
				}
			</StyledFormSubmissionInfo>
			<StyledFormSubmissionError>
				{
					fileSubmissionError && (
						<span>Ekki tókst að hlaða upp skrám.</span>
					)
				}
				{
					localFieldErrorsPresent && (
						<span>Einhverjar upplýsingar eru ekki á réttu formi.</span>
					)
				}
				{
					!localFieldErrorsPresent && formSubmissionError && errorText()
				}
			</StyledFormSubmissionError>
			{
				fileSubmissionError && (
					<StyledButtonWrapper>
						<Button
							type="button"
							loading={fileSubmissionLoading}
							onClick={onUploadFiles}>
							<span>Prófa aftur</span>
						</Button>
					</StyledButtonWrapper>
				)
			}
		</>
	);
};

FormSubmissionInfo.propTypes = {
	errors: PropTypes.object.isRequired,
	fileSubmissionLoading: PropTypes.bool.isRequired,
	formSubmissionError: PropTypes.bool.isRequired,
	formSubmissionErrorMessage: PropTypes.string,
	formSubmissionErrorStatus: PropTypes.number
};

export default FormSubmissionInfo;
